module.exports = __webpack_public_path__ + "static/img/YORK校区.77f81bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/YORK/YORK校区.png
// module id = IhG5
// module chunks = 0